/**
 * Power Kitchen LP — FAQ section
 * Single-open accordion. Event delegation on the accordion container.
 * Panel height is animated via inline max-height (computed from scrollHeight)
 * so the CSS transition works regardless of answer length.
 */
document.addEventListener('DOMContentLoaded', function () {
  var accordionEls = document.querySelectorAll('[data-lp-faq]');
  if (!accordionEls.length) {
    return;
  }

  function closeItem(itemEl) {
    var triggerEl = itemEl.querySelector('[data-lp-faq-trigger]');
    var panelEl = itemEl.querySelector('[data-lp-faq-panel]');
    var iconEl = itemEl.querySelector('[data-lp-faq-icon]');

    itemEl.classList.remove('lp-pk-faq__item--open');

    if (triggerEl) {
      triggerEl.setAttribute('aria-expanded', 'false');
    }

    if (panelEl) {
      panelEl.style.maxHeight = '0px';
    }

    if (iconEl) {
      iconEl.textContent = '+';
    }
  }

  function openItem(itemEl) {
    var triggerEl = itemEl.querySelector('[data-lp-faq-trigger]');
    var panelEl = itemEl.querySelector('[data-lp-faq-panel]');
    var iconEl = itemEl.querySelector('[data-lp-faq-icon]');

    itemEl.classList.add('lp-pk-faq__item--open');

    if (triggerEl) {
      triggerEl.setAttribute('aria-expanded', 'true');
    }

    if (panelEl) {
      panelEl.style.maxHeight = panelEl.scrollHeight + 'px';
    }

    if (iconEl) {
      iconEl.textContent = '−';
    }
  }

  function initAccordion(accordionEl) {
    var itemEls = accordionEl.querySelectorAll('[data-lp-faq-item]');

    itemEls.forEach(function (itemEl) {
      if (itemEl.classList.contains('lp-pk-faq__item--open')) {
        var panelEl = itemEl.querySelector('[data-lp-faq-panel]');
        if (panelEl) {
          panelEl.style.maxHeight = panelEl.scrollHeight + 'px';
        }
      }
    });

    accordionEl.addEventListener('click', function (event) {
      var triggerEl = event.target.closest('[data-lp-faq-trigger]');
      if (!triggerEl) {
        return;
      }

      var itemEl = triggerEl.closest('[data-lp-faq-item]');
      if (!itemEl) {
        return;
      }

      var isOpen = itemEl.classList.contains('lp-pk-faq__item--open');

      if (isOpen) {
        closeItem(itemEl);
      } else {
        openItem(itemEl);
      }
    });
  }

  try {
    accordionEls.forEach(initAccordion);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('lp-power-kitchen-faq: init failed', error);
  }
});
